import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import  api from '../common/api';
import ConfirmDialog from '../common/ConfirmDialog'
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from "@material-ui/core/Button";

class ClientWorkOrderExpenseType extends React.Component {

  constructor(props) {
    super(props);
      this.state = {
        client:{},
        action:'new',
        client_expenses:[],
        work_order_expense_types:[],
        dialog: {open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
        delete_dialog: {open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
      }

  }  

  async componentDidMount() {
    var params = this.getParams();
    var client_id = params.id
    await this.getClient(client_id)
    await this.getClientExpenses(client_id)
    await this.getWorkOrderExpenseTypes()
    this.setState({loading:false, client_id: client_id})
  }

  getParams(){
    return this.props.match.params
  }  

  getWorkOrderExpenseTypes = async() =>{
    const token = localStorage.getItem('userToken')
    return await axios
         .get(api.dropdowns().ot(),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              this.setState({work_order_expense_types: res.data.work_order_expense_types})
          })
          .catch(err =>{console.log(err)
          })
  }

  getClient = async(id) =>{
    const token = localStorage.getItem('userToken')
    return await axios
         .get(api.clients().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              this.setState({client: res.data[0]})
          })
          .catch(err =>{console.log(err)
          })
  }

  getClientExpenses = async(id) =>{
    const token = localStorage.getItem('userToken')
    return await axios
         .get(api.client_expenses().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              var action = (res.data.length === 0) ? 'new' : 'edit'
              var client_expenses = (res.data.length === 0) ? [{client_id: '', work_order_expense_type_id:''}] : res.data
              this.setState({client_expenses: client_expenses, action: action})
          })
          .catch(err =>{console.log(err)
          })
  }

  handleChange = (e) => {
    var element = e.target.name.split('.')
    var key = element[0]
    var id = element[1]
    var val = e.target.value

    var client_expenses = this.state.client_expenses
    client_expenses[id][key] = val
    this.setState({client_expenses: client_expenses})
  };

  handleSubmit = (event) => {
    var formData = new FormData();
    var dialog = this.state.dialog
    event.preventDefault();
    event.stopPropagation();
    let self = this
    var i = 0;
    this.state.client_expenses.map((val,idx)=>{
      if (val.work_order_expense_type_id !== ''){
        formData.set("client_expense["+i+"][client_id]", this.state.client_id);
        formData.set("client_expense["+i+"][work_order_expense_type_id]", (val.work_order_expense_type_id) ? val.work_order_expense_type_id : '');
        formData.set("client_expense["+i+"][description]", (val.description) ? val.description : '');
        i++;
      }
    })
    const token = localStorage.getItem('userToken')
    if (this.state.action ==='new'){
        axios.post(api.client_expenses().post(),
           formData,
           {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
           )
          .then((response)=> {
              dialog.title = 'Tipos de gasto Cliente'
              dialog.success = 1
              dialog.message = 'Tipos de gastos creados con éxito!'
              dialog.open = true
              self.setState({dialog: dialog})
          })
          .catch(function (error) {
              dialog.title = 'Tipos de gasto cliente'
              dialog.message = 'Ha ocurrido un error!'
              dialog.open = true
              dialog.success = 0
              var promise = new Promise(function(resolve, reject) {
                resolve(error.response.data);
                dialog.errors = error.response.data         
              });
              self.setState({dialog: dialog})
        })
    } else {
      formData.append('_method', 'patch');
      axios.post(api.client_expenses().patch(this.state.client_id),
         formData,
         {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
              dialog.title = 'Tipos de gasto cliente'
              dialog.success = 1
              dialog.open = true
              dialog.message = 'Tipos de gastos modificados con éxito!'
              self.setState({dialog: dialog})
        })
        .catch(function (error) {
          dialog.title = 'Tipos de gasto cliente'
          dialog.open = true
          dialog.message = 'Ha ocurrido un error!'
          dialog.success = 0
          var promise = new Promise(function(resolve, reject) {
            resolve(error.response.data);
            dialog.errors = error.response.data         
          });
          self.setState({dialog: dialog})
      })

    }
  }

  handleDialogClose = () => {
    var dialog = this.state.dialog
    dialog.open = false
    dialog.errors = []
    var delete_dialog = this.state.delete_dialog
    delete_dialog.open = false
    delete_dialog.errors = []
    this.setState({dialog: dialog, delete_dialog: delete_dialog})
  }

  handleDialogAccept = () =>{
    if (this.state.dialog.success === 1){
        window.location.href='/clients'
    } else {
      this.handleDialogClose()
    }
  }

  handleDialogCancel = () =>{
    this.handleDialogClose()
  }


  handleCancelButton = () => {
    window.location.href='/clients'
  }

  handleNewExpenseType = (e) => {
    e.preventDefault()
    var client_expenses = this.state.client_expenses
    client_expenses.push({work_order_expense_type_id:'', client_id:''})
    this.setState({client_expenses: client_expenses})
  }

  handleRemoveExpenseType = (e,id) => {
    e.preventDefault()
    var delete_dialog = this.state.delete_dialog
    delete_dialog.title = 'Costos cliente'
    delete_dialog.success = 0
    delete_dialog.message = 'Esta seguro de eliminar el costo?'
    delete_dialog.open = true
    this.setState({delete_dialog: delete_dialog, delete_id: id})

/*    e.preventDefault()
    var client_expenses = this.state.client_expenses
    client_expenses = client_expenses.filter((s, sidx) => id !== sidx);
    this.setState({client_expenses: client_expenses})*/
  }

  handleDelete = async () => {
    var id = this.state.delete_id
    var client_expenses = this.state.client_expenses
    var delete_dialog = this.state.delete_dialog
    var client_expense = {}
    client_expenses.map((val,idx)=>{
        if (idx === id){
          client_expense = val
        }
    })
    if (client_expense.id !== undefined){
      let self = this
      const token = localStorage.getItem('userToken')
      await axios.delete(api.client_expenses().delete(client_expense.id),{ headers: {"Authorization" : `Bearer ${token}`}},
          )
        .then((response)=> {
          client_expenses = client_expenses.filter((s, sidx) => id !== sidx);
          delete_dialog.title = 'Costos cliente'
          delete_dialog.success = 1
          delete_dialog.open = true
          delete_dialog.message = 'Costos eliminados con éxito!'
        })
        .catch(function (error) {
          delete_dialog.title = 'Costos cliente'
          delete_dialog.success = 1
          delete_dialog.open = true
          delete_dialog.message = 'Ha ocurrido al eliminar el costo. Contact a su administrador!'
          self.setState({delete_dialog: delete_dialog})
          console.log(error)
        })
    } else {
      delete_dialog.title = 'Costos cliente'
      delete_dialog.success = 1
      delete_dialog.open = true
      delete_dialog.message = 'Costos eliminados con éxito!'
	  client_expenses = client_expenses.filter((s, sidx) => id !== sidx);
    }
    this.setState({client_expenses: client_expenses, delete_dialog: delete_dialog})
  }



  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
       MuiInput: {
          underline: {
              '&:before': {
                borderBottom: '0px',
              }
          }
        },
        MuiTypography:{
          caption:{
            fontWeight: 600
          }
        },
        MuiInputBase:{
          input:{
            borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
          }
        } 
    }
  });     

  render() {
    return (
      <MuiThemeProvider theme={this.getMuiTheme()}>

      <React.Fragment>
        <Container fluid className="main-content-container px-4 position-relative">
        {(!this.state.loading)
          ? 
            <React.Fragment>
              <ConfirmDialog 
                      confirm_dialog={this.state.delete_dialog.open} 
                      title={this.state.delete_dialog.title}
                      message={this.state.delete_dialog.message}
                      onClose={this.handleDialogClose} 
                      onAccept={this.handleDelete}
                      onCancel={this.handleDialogCancel}
                      errors={this.state.delete_dialog.errors}
                />
            
              <ConfirmDialog 
                      confirm_dialog={this.state.dialog.open} 
                      title={this.state.dialog.title}
                      message={this.state.dialog.message}
                      onClose={this.handleDialogClose} 
                      onAccept={this.handleDialogAccept}
                      onCancel={this.handleDialogCancel}
                      errors={this.state.dialog.errors}
                />
              <Row noGutters className="page-header">
                  <Typography variant="h6">Tipos de gastos {this.state.client.business_name}</Typography>
              </Row>
              {(this.state.client_expenses.map((val, idx)=>{
                return (
                  <React.Fragment>
                    <Row className="ml-1 mt-1">
                      <TextField
                        id={"work_order_expense_type_id."+idx}
                        name={"work_order_expense_type_id."+idx}
                        select
                        margin="normal"
                        className="mr-2 mt-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={this.handleChange}
                        value={val.work_order_expense_type_id}
                        inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Gasto</Typography></InputAdornment>,
                            style:{fontSize: '0.75rem'}
                        }}
                        >
                        {this.state.work_order_expense_types.map((option) => (
                        <MenuItem key={option.id} value={option.id} style={{fontSize: '0.75rem'}}>
                          {option.name}
                        </MenuItem>
                      ))}
                      </TextField>
		              <TextField
		                id={"description"+idx}
		                name={"description."+idx}
		                type="text"
		                margin="normal"
		                className="mr-2 mt-1"
		                InputLabelProps={{
		                  shrink: true
		                }}
		                onChange={this.handleChange}
		                value={val.description}
		                inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
		                InputProps={{
		                    startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Descripción</Typography></InputAdornment>,
		                    style:{fontSize: '0.75rem'}
		                }}
		                />
                      <IconButton size="small">
                        <AddIcon onClick={(e)=> {this.handleNewExpenseType(e)}} />
                      </IconButton>
                      <IconButton size="small">
                        <RemoveIcon  onClick={(e) => {this.handleRemoveExpenseType(e,idx)}} />
                      </IconButton>
                    </Row>
                  </React.Fragment>
                )
              }))}
              <Button className="mr-1 mt-3" variant="contained" color="primary" onClick={(e)=>{this.handleSubmit(e)}} style={{fontSize: '0.7rem'}}>
                Guardar
              </Button>
              <Button variant="contained" className="mr-1 mt-3" color="secondary" href={"/clients"}  style={{fontSize: '0.7rem'}}>
                Cancelar
              </Button>


            </React.Fragment>
          :
            <LinearProgress />          
        }
        </Container>
      </React.Fragment>
      </MuiThemeProvider>

    )
  }
}

export default ClientWorkOrderExpenseType;